import { Tab } from "@headlessui/react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useBreadcrumb } from "hooks/useBreadcrumb";

import { getClaimType } from "js/formatting";
import { claimsFiltering } from "js/serviceAndClaimsFiltering";
import { useCustomerClaimsMapper } from "hooks/useCustomerClaimsMapper";

import ClaimsTab from "components/ServicesAndClaims/ClaimsTab";
import ServicesAndClaimsCard from "components/ServicesAndClaims/ServicesAndClaimsCard";
import ServicesAndClaimsFilterModel from "components/ModalDialogs/ServicesAndClaimsFilterModel";
import { getImage } from "js/utilities";

export default function ServicesClaims() {
  const { t } = useTranslation();
  let debounceFunction; //timer identifier
  let debounceTimer = 5; //timer in ms
  const { claims: customerClaims } = useSelector((state) => state.data);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabGroupIndex, setTabGroupIndex] = useState(0);
  const [claimsData, setClaimsData] = useState([]);
  const [modalState, setModalState] = useState(false);
  const [selectedClaimsCategory, setSelectedClaimsCategory] = useState("");
  const [startsWith, setStartsWith] = useState();
  const [type, setType] = useState();
  const [sortby, setSortby] = useState();
  const [typeServices, setTypeServices] = useState();
  const [sortbyServices, setSortbyServices] = useState();
  const [category, setCategory] = useState([]);
  const { claims } = useCustomerClaimsMapper();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  useEffect(() => {
    if (tabGroupIndex === 0) {
      setType(searchParams.get("type"));
      setTypeServices(searchParams.get("type"));
      setSortbyServices(searchParams.get("sortby"));
      setClaimsData(
        claimsFiltering(
          claims,
          selectedClaimsCategory,
          searchParams.get("type"),
          searchParams.get("sortby"),
          startsWith
        )
      );
    }
    // if (tabGroupIndex === 0) {
    //   setType(searchParams.get("type"));
    //   setSortby(searchParams.get("sortby"));
    //   setServicesData(
    //     servicesFiltering(
    //       services,
    //       selectedServicesCategory,
    //       searchParams.get("type"),
    //       searchParams.get("sortby"),
    //       startsWithServices
    //     )
    //   );
    // }
  }, [searchParams]);
  useEffect(() => {
    setClaimsData(claims);
  }, [claims]);
  useEffect(() => {
    let claimsStatus = [];
    if (customerClaims?.length > 0) {
      customerClaims?.map((c) => {
        let claimType = claimsStatus?.find(
          (x) =>
            x?.value?.toLowerCase() ===
            c?.claimType?.toLowerCase().replace(" ", "")
        );
        if (!claimType && c?.claimType !== "")
          claimsStatus.push({
            value: c?.claimType?.replace(" ", "")?.toLowerCase(),
            display: getClaimType(c?.claimType),
          });
      });
      setCategory(claimsStatus);
    }
  }, [customerClaims]);
  useBreadcrumb([
    { name: t("CustomerServiceRequestClaims-home"), url: "/policies" },
    { name: t("CustomerServiceRequestClaims-services-claims"), url: "#" },
  ]);
  return (
    <>
      <div className="container mb-8">
        <h1>{t("CustomerServiceAndClaim-title")}</h1>
        <p>{t("CustomerServiceAndClaim-subtitle")}</p>
        <hr />
      </div>
      <div className="container ui-component-spacing">
        <div>
          <img
            alt="couple looking at ipad"
            src={getImage("image7.jpg")}
            className="w-full h-auto max-w-none"
          />
        </div>

        <div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6 md:mt-6 lg:-mt-[6.25rem]">
          {/* Life Insurance Policy Services */}
          <ServicesAndClaimsCard
            titleFont="font-header text-theme-text-quinary"
            data={{
              title: t("CustomerServiceAndClaim-card-1-title"),
              desc: t("CustomerServiceAndClaim-card-1-subtitle"),
              exploreLink: t("CustomerServiceAndClaim-card-1-explore-link"),
              links: [
                {
                  title: t("CustomerServiceAndClaim-card-1-link-1-title"),
                  icon: t("CustomerServiceAndClaim-card-1-link-1-icon"),
                  url: t("CustomerServiceAndClaim-card-1-link-1-url"),
                },
                {
                  title: t("CustomerServiceAndClaim-card-1-link-2-title"),
                  icon: t("CustomerServiceAndClaim-card-1-link-2-icon"),
                  url: t("CustomerServiceAndClaim-card-1-link-2-url"),
                },
                {
                  title: t("CustomerServiceAndClaim-card-1-link-3-title"),
                  icon: t("CustomerServiceAndClaim-card-1-link-3-icon"),
                  url: t("CustomerServiceAndClaim-card-1-link-3-url"),
                },
              ],
            }}
          />
          {/* Claims Services */}
          <ServicesAndClaimsCard
            titleFont="font-header text-theme-text-quinary"
            data={{
              title: t("CustomerServiceAndClaim-card-2-title"),
              desc: t("CustomerServiceAndClaim-card-2-subtitle"),
              exploreLink: t("CustomerServiceAndClaim-card-2-explore-link"),
              links: [
                {
                  title: t("CustomerServiceAndClaim-card-2-link-1-title"),
                  icon: t("CustomerServiceAndClaim-card-2-link-1-icon"),
                  url: t("CustomerServiceAndClaim-card-2-link-1-url"),
                },
                {
                  title: t("CustomerServiceAndClaim-card-2-link-2-title"),
                  icon: t("CustomerServiceAndClaim-card-2-link-2-icon"),
                  url: t("CustomerServiceAndClaim-card-2-link-2-url"),
                },
              ],
            }}
          />
          <ServicesAndClaimsCard
            titleFont="font-header text-theme-text-quinary"
            data={{
              title: t("CustomerServiceAndClaim-card-3-title"),
              desc: t("CustomerServiceAndClaim-card-3-subtitle"),
              exploreLink: t("CustomerServiceAndClaim-card-3-explore-link"),
              links: [
                {
                  title: t("CustomerServiceAndClaim-card-3-link-1-title"),
                  icon: t("CustomerServiceAndClaim-card-3-link-1-icon"),
                  url: t("CustomerServiceAndClaim-card-3-link-1-url"),
                },
                {
                  title: t("CustomerServiceAndClaim-card-3-link-2-title"),
                  icon: t("CustomerServiceAndClaim-card-3-link-2-icon"),
                  url: t("CustomerServiceAndClaim-card-3-link-2-url"),
                },
                {
                  title: t("CustomerServiceAndClaim-card-3-link-3-title"),
                  icon: t("CustomerServiceAndClaim-card-3-link-3-icon"),
                  url: t("CustomerServiceAndClaim-card-3-link-3-url"),
                },
              ],
            }}
          />
        </div>
      </div>

      <div className="container ui-component-spacing">
        <h2>{t("CustomerServiceRequestClaims-my-claims")}</h2>
        <hr />

        <Tab.Group
          selectedIndex={selectedTabIndex}
          onChange={(tabGroupIndex) => {
            setTabGroupIndex(tabGroupIndex);
          }}
        >
          <div className="ui-card flex-grow px-2 p-1 md:px-4">
            <Tab.List>
              {/* {services?.length > 0 && (
                  <Tab className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${selectedTabIndex === 0
                    ? ""
                    : "text-ui-blue"
                    }`}
                    onClick={() => { setSelectedTabIndex(0); }} >
                    Service Requests
                  </Tab>
                )} */}
              {/* {claims?.length > 0 && ( */}
              <Tab
                className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                  selectedTabIndex === 1 ? "" : "text-ui-blue"
                }`}
                onClick={() => {
                  setSelectedTabIndex(1);
                }}
              >
                {t("CustomerServiceRequestClaims-claims")}
              </Tab>
              {/* )} */}
            </Tab.List>
          </div>

          <div className="mt-4 lg:flex lg:items-start lg:justify-between lg:mt-6">
            {/* {tabGroupIndex === 0 && (
                <div className="hidden lg:flex lg:items-center">
                  <label
                    id="ID_categoryLabel"
                    htmlFor="ID_category"
                    className="mr-2"
                  >
                    Category
                  </label>
                  <select
                    id="ID_serviceCategory"
                    aria-labelledby="ID_serviceCategoryLabel"
                    value={selectedServicesCategory}
                    onChange={(e) => {
                      setServicesData(
                        servicesFiltering(
                          services,
                          e.target.value?.trim(),
                          typeServices,
                          sortbyServices,
                          startsWithServices
                        )
                      );
                      setSelectedServicesCategory(e.target.value?.trim());
                    }}
                  >
                    <option value="">Show all</option>
                    <option value="processed">Processed</option>
                    <option value="pending">Pending</option>
                    <option value="denied">Denied</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              )} */}
            {tabGroupIndex === 0 && (
              <div className="hidden lg:flex lg:items-center">
                <label
                  id="ID_categoryLabel"
                  htmlFor="ID_category"
                  className="mr-2"
                >
                  {t("CustomerServiceRequestClaims-category")}
                </label>
                <select
                  id="ID_category"
                  aria-labelledby="ID_categoryLabel"
                  value={selectedClaimsCategory}
                  onChange={(e) => {
                    setClaimsData(
                      claimsFiltering(
                        claims,
                        e.target.value?.trim(),
                        type,
                        sortby,
                        startsWith
                      )
                    );
                    setSelectedClaimsCategory(e.target.value?.trim());
                  }}
                >
                  <option value="">Show all</option>
                  {/* <option value="deathClaim">Death Claim</option> */}
                  {category?.length &&
                    category.map((c, idx) => (
                      <option
                        value={c.value}
                        key={`user category selection - ${idx}`}
                      >
                        {c.display}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <div className="hidden lg:flex lg:items-start lg:mx-4">
              <label
                id="ID_searchPolicyLabel"
                htmlFor="ID_searchPolicy"
                className="mt-2 mr-2"
              >
                {t("CustomerServiceRequestClaims-search-by-policy")}
              </label>
              <div>
                {/* {tabGroupIndex === 0 && (
                    <div className="flex flex-col flex-1 w-full relative">
                      <input
                        id="ID_serviceSearchPolicy"
                        aria-labelledby="ID_serviceSearchPolicyLabel"
                        aria-describedby="ID_serviceSearchPolicyError"
                        type="text"
                        className="pl-8 w-[350px] "
                        placeholder="Enter policy number or policy holder name"
                        defaultValue={startsWithServices}
                        onChange={(e) => setStartsWithServices(e.target.value)}
                        onKeyUp={() => {
                          clearTimeout(debounceFunction);
                          debounceFunction = setTimeout(async () => {
                            setServicesData(
                              servicesFiltering(
                                services,
                                selectedServicesCategory,
                                typeServices,
                                sortbyServices,
                                startsWithServices
                              )
                            );
                          }, debounceTimer);
                        }}
                        onKeyDown={() => {
                          clearTimeout(debounceFunction);
                        }}
                      />
                      <svg
                        className="ui-icon text-theme-action w-4 h-4 absolute ml-2 mt-3"
                        focusable="false"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <use href="#ui-icon-search"></use>
                      </svg>
                    </div>
                  )} */}
                {tabGroupIndex === 0 && (
                  <div className="flex flex-col flex-1 w-full relative">
                    <input
                      id="ID_searchPolicy"
                      aria-labelledby="ID_searchPolicyLabel"
                      aria-describedby="ID_searchPolicyError"
                      type="text"
                      className="pl-8 w-[350px] "
                      defaultValue={startsWith}
                      placeholder={t(
                        "CustomerServiceRequestClaims-placeholder"
                      )}
                      onChange={(e) => setStartsWith(e.target.value)}
                      onKeyUp={() => {
                        clearTimeout(debounceFunction);
                        debounceFunction = setTimeout(async () => {
                          setClaimsData(
                            claimsFiltering(
                              claims,
                              selectedClaimsCategory,
                              type,
                              sortby,
                              startsWith
                            )
                          );
                        }, debounceTimer);
                      }}
                      onKeyDown={() => {
                        clearTimeout(debounceFunction);
                      }}
                    />
                    <svg
                      className="ui-icon text-theme-action w-4 h-4 absolute ml-2 mt-3"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-search"></use>
                    </svg>
                  </div>
                )}
                <div id="ID_searchPolicyError" className="text-ui-red"></div>
              </div>
            </div>

            <div>
              <button
                className="ui-btn-primary"
                onClick={() => setModalState(true)}
              >
                {t("CustomerServiceRequestClaims-filter-options")}
              </button>
            </div>
          </div>

          <Tab.Panels className="mt-4 lg:mt-6">
            <Tab.Panel>
              {/* Service Requests */}
              {/* {servicesData?.length === 0 ? (
                <Tab.Panel>
                  <div className="border border-dashed border-ui-gray p-6 my-6">
                    <div className="text-center">
                      <div className="text-xl font-bold">
                        Currently there are no service requests
                      </div>
                      <div className="mt-1 text-theme-text-quaternary text-sm">
                        No service requests are available for you to work on at
                        this time
                      </div>
                    </div>
                  </div>
                </Tab.Panel>
              ) : (
                <ServiceRequestsTab data={servicesData} />
              )} */}
              {/* Claims */}
              {claimsData?.length === 0 ? (
                <div className="border border-dashed border-ui-gray p-6 my-6">
                  <div className="text-center">
                    <div className="text-xl font-bold">
                      {t("CustomerServiceRequestClaims-no-claims-title")}
                    </div>
                    <div className="mt-1 text-theme-text-quaternary text-sm">
                      {t("CustomerServiceRequestClaims-no-claims-message")}
                    </div>
                  </div>
                </div>
              ) : (
                <ClaimsTab data={claimsData} />
              )}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
      {/* <!-- dialogs --> */}
      <ServicesAndClaimsFilterModel
        modalState={modalState}
        setModalState={setModalState}
      />
      {/* <!-- dialogs --> */}
    </>
  );
}
